/* ============================================================
   deco-play.js — 「遊んでいる最中」装飾レイヤー
   個数・位置・回転・不透明度は DECO_VARIANTS の配列を編集するだけで調整できる。
   後で本物のカード画像（透過PNG）に差し替える場合は、下の svg◯◯ 関数を
   `<img src="...">` を返す関数に置き換えればOK。
   ============================================================ */
(function () {
  'use strict';

  /* ---------- アイテム描画 ----------
     カードは実商品のカード画像（assets/deco-card-*.png）。
     追加したい時は画像をassetsに入れて imgCard('ファイル名', 表示幅px, 角丸か) を使う */
  var ASSET_BASE = '';
  function imgCard(file, w, round) {
    return '<img class="dp-img' + (round ? ' dp-img--round' : '') + '" src="' + ASSET_BASE + file + '" width="' + w + '" alt="" loading="lazy">';
  }
  function svgCoin() {
    return '<svg width="30" height="30" viewBox="0 0 30 30"><circle cx="15" cy="15" r="13.5" fill="#F2A83A" stroke="#D98B1F" stroke-width="2"/><text x="15" y="21" text-anchor="middle" font-size="15" font-weight="900" fill="#fff" font-family="sans-serif">¥</text></svg>';
  }
  function svgPencil() {
    return '<svg width="42" height="14" viewBox="0 0 42 14"><rect x="0" y="3" width="30" height="8" rx="2" fill="#5BC2E7"/><polygon points="30,1.5 41,7 30,12.5" fill="#F7D08A"/><polygon points="37,3.5 41,7 37,10.5" fill="#3A2E24"/></svg>';
  }
  function svgSpark() {
    return '<svg width="22" height="22" viewBox="0 0 22 22"><path d="M11 0 L13.2 8.8 L22 11 L13.2 13.2 L11 22 L8.8 13.2 L0 11 L8.8 8.8 Z" fill="#fff"/></svg>';
  }

  /* ---------- 配置設定 ----------
     t/l: top/left（%）  r: 回転（deg）  pc: trueならPCのみ表示
     s: サイズ倍率  mv: 動きの強さ 1=ひかえめ 2=ふつう 3=大きくゆらゆら
     見出し・学年フィルターに被らないよう、上端の中央帯は避けて左右端に寄せている */
  /* カード: num1=九九数字(ピンク) num5=同(黄) kanji1/2=つな漢字 moon/holiday=ワードマン(横長)
     キャラ: sennin=つるかめ仙人 beethoven=ベートーベン mozart=モーツァルト
             kintore=筋トレ rakugo=着物キャラ（既存の custom_deco_img を再利用） */
  var DECO_VARIANTS = {
    /* トップ「教科別一覧」：黄色背景。白キラキラOK・やや濃いめ */
    subject: {
      opacity: 0.7,
      items: [
        { t: 0.5, l: 88, r: 12,  s: 1.4, mv: 3, k: function () { return svgCoin(); } },
        { t: 6,   l: -3, r: -14, s: 1,   mv: 2, k: function () { return imgCard('deco-card-kanji1.png', 52, true); } },  /* 左端で見切れ */
        { t: 13,  l: 90, r: -18, s: 1,   mv: 3, k: function () { return imgCard('deco-card-num1.png', 50); } },
        { t: 24,  l: 2,  r: 8,   s: 1.4, mv: 1, k: function () { return svgPencil(); } },
        { t: 33,  l: 88, r: -8,  s: 1.3, mv: 3, k: function () { return svgSpark(); } },
        { t: 46,  l: -2, r: 16,  s: 1,   mv: 2, k: function () { return imgCard('deco-card-moon.png', 74); } },
        { t: 58,  l: 92, r: 10,  s: 1.3, mv: 3, k: function () { return svgPencil(); } },
        { t: 72,  l: 2,  r: -10, s: 1.5, mv: 2, k: function () { return svgCoin(); } },
        { t: 82,  l: 88, r: 18,  s: 1,   mv: 3, k: function () { return imgCard('deco-card-kanji2.png', 52, true); } },
        { t: 94,  l: 5,  r: -6,  s: 1.2, mv: 1, k: function () { return svgSpark(); } },
        { t: 19,  l: 87, r: -8,  s: 1,   mv: 2, k: function () { return imgCard('custom_deco_img05.png', 84); } },   /* ベートーベン */
        { t: 41,  l: 90, r: 10,  s: 1,   mv: 3, k: function () { return imgCard('custom_deco_img11.png', 80); } },   /* 筋トレ */
        { t: 49.3, l: 54, r: -10, s: 1, mv: 2, k: function () { return imgCard('custom_deco_img04.png', 76); } },   /* つるかめ仙人: 国語見出し横の余白帯（カード非被り） */
        { t: 38,  l: 4,  r: -16, s: 1,   mv: 2, k: function () { return imgCard('deco-card-holiday.png', 74); }, pc: true },
        { t: 66,  l: 94, r: 6,   s: 1.3, mv: 3, k: function () { return svgSpark(); },                            pc: true }
      ]
    },
    /* 商品一覧：淡い背景。白キラキラなし・控えめ。
       上端は「商品」見出しの右横の余白のみ、フィルター帯（およそ3〜12%）は避ける */
    collection: {
      opacity: 0.5,
      items: [
        { t: 0.2, l: 68, r: -12, s: 1.3, mv: 2, k: function () { return svgPencil(); } },
        { t: 15,  l: -3, r: 10,  s: 1,   mv: 2, k: function () { return imgCard('deco-card-kanji2.png', 52, true); } },  /* 左端で見切れ */
        { t: 24,  l: 93, r: -16, s: 1.3, mv: 3, k: function () { return svgCoin(); } },
        { t: 37,  l: 2,  r: -8,  s: 1,   mv: 1, k: function () { return imgCard('deco-card-num5.png', 50); } },
        { t: 49,  l: 90, r: 14,  s: 1,   mv: 3, k: function () { return imgCard('deco-card-holiday.png', 74); } },
        { t: 61,  l: -1, r: 16,  s: 1.3, mv: 2, k: function () { return svgPencil(); } },
        { t: 73,  l: 92, r: -10, s: 1,   mv: 3, k: function () { return imgCard('deco-card-kanji1.png', 52, true); } },
        { t: 85,  l: 2,  r: 12,  s: 1.5, mv: 2, k: function () { return svgCoin(); } },
        { t: 96,  l: 88, r: -14, s: 1,   mv: 1, k: function () { return imgCard('deco-card-num1.png', 50); } },
        { t: 30,  l: 2,  r: 8,   s: 1,   mv: 2, k: function () { return imgCard('custom_deco_img08.png', 84); } },   /* モーツァルト */
        { t: 67,  l: 91, r: -8,  s: 1,   mv: 2, k: function () { return imgCard('custom_deco_img12.png', 88); } },   /* 着物キャラ */
        { t: 79,  l: -1, r: 10,  s: 1,   mv: 3, k: function () { return imgCard('custom_deco_img11.png', 78); } },   /* 筋トレ */
        { t: 31,  l: 94, r: 8,   s: 1.3, mv: 3, k: function () { return svgPencil(); },                            pc: true },
        { t: 55,  l: 4,  r: -12, s: 1.4, mv: 2, k: function () { return svgCoin(); },                              pc: true },
        { t: 91,  l: 40, r: 10,  s: 1,   mv: 3, k: function () { return imgCard('deco-card-moon.png', 74); },      pc: true }
      ]
    }
  };
  /* 白・クリーム背景の紹介セクション用：さらに控えめ。白キラキラなし */
  DECO_VARIANTS.paper = {
    opacity: 0.35,
    items: [
      { t: 4,  l: 88, r: 12,  s: 1,   mv: 2, k: function () { return svgCoin(); } },
      { t: 18, l: -2, r: -12, s: 1,   mv: 2, k: function () { return imgCard('deco-card-num1.png', 46); } },
      { t: 42, l: 91, r: 14,  s: 1,   mv: 3, k: function () { return imgCard('deco-card-kanji1.png', 48, true); } },
      { t: 60, l: 2,  r: 8,   s: 1.2, mv: 1, k: function () { return svgPencil(); } },
      { t: 78, l: 90, r: -10, s: 1,   mv: 2, k: function () { return imgCard('deco-card-moon.png', 64); } },
      { t: 92, l: 3,  r: -8,  s: 1,   mv: 3, k: function () { return svgCoin(); } }
    ]
  };

  function renderLayer(el) {
    var conf = DECO_VARIANTS[el.getAttribute('data-deco-play')];
    if (!conf || el.getAttribute('data-deco-done')) return;
    el.setAttribute('data-deco-done', '1');
    ASSET_BASE = el.getAttribute('data-asset-base') || '';
    var html = '';
    for (var i = 0; i < conf.items.length; i++) {
      var it = conf.items[i];
      /* mv（動きの強さ）→ 浮遊距離・横ゆれ・回転ゆれ・周期に変換 */
      var mv = it.mv || 2;
      var fy = [-6, -12, -22][mv - 1];                       /* 縦の浮遊距離(px) */
      var fx = [0, 3, 7][mv - 1] * (it.r < 0 ? -1 : 1);      /* 横ゆれ(px)。回転方向に合わせる */
      var rd = [3, 6, 10][mv - 1];                           /* 回転のゆれ(deg) */
      var dur = [7.5, 6, 4.2][mv - 1] + (i % 3) * 0.7;       /* 周期: 大きく動くものほど速く */
      html += '<span class="dp-it' + (it.pc ? ' dp-it--pc' : '') + '" style="top:' + it.t + '%;left:' + it.l + '%;opacity:' + conf.opacity + ';scale:' + (it.s || 1) + '">'
        + '<span class="dp-pop" style="--pd:' + ((i % 5) * 0.1).toFixed(1) + 's">'
        + '<span class="dp-fl" style="--r:' + it.r + 'deg;--rd:' + rd + 'deg;--fy:' + fy + 'px;--fx:' + fx + 'px;--d:' + dur.toFixed(1) + 's;--fd:' + (0.6 + (i % 5) * 0.1).toFixed(1) + 's">'
        + it.k() + '</span></span></span>';
    }
    el.innerHTML = html;

    var items = el.querySelectorAll('.dp-it');
    if (!('IntersectionObserver' in window)) {
      for (var j = 0; j < items.length; j++) items[j].classList.add('in');
      return;
    }
    /* 入ったらポップイン。画面から完全に外れたら（+80pxの余裕つき）リセットして、
       次にスクロールで見えたときもう一度ポップインさせる */
    var ioIn = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) en.target.classList.add('in');
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    var ioOut = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) en.target.classList.remove('in');
      });
    }, { rootMargin: '80px 0px 80px 0px' });
    for (var k = 0; k < items.length; k++) { ioIn.observe(items[k]); ioOut.observe(items[k]); }
  }

  function init() {
    var layers = document.querySelectorAll('[data-deco-play]');
    for (var i = 0; i < layers.length; i++) renderLayer(layers[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
